import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, ArrowLeft, Construction } from 'lucide-react';
/**
 * Coming Soon placeholder page for features under development
 * Used by Finance and Co-curricular role dashboards
 */
const ComingSoon = () => {
    const navigate = useNavigate();
    const userRole = localStorage.getItem('user_role') || 'user';

    // Role-specific messages
    const roleMessages = {
        'finance': {
            title: 'Finance Dashboard',
            description: 'Financial management tools, budget tracking, and expense reporting features are coming soon.',
            color: '#10B981' // emerald
        },
        'cocurricular': {
            title: 'Activities Dashboard',
            description: 'Co-curricular activity management, event scheduling, and student participation tracking coming soon.',
            color: '#8B5CF6' // violet
        },
        'default': {
            title: 'Feature Coming Soon',
            description: 'This feature is currently under development and will be available in a future update.',
            color: '#F59E0B' // amber
        }
    };

    const content = roleMessages[userRole] || roleMessages['default'];

    return (
        <>
            <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
                <div className="max-w-md w-full text-center">
                    {/* Icon */}
                    <div
                        className="w-24 h-24 rounded-full mx-auto mb-6 flex items-center justify-center"
                        style={{ backgroundColor: `${content.color}20` }}
                    >
                        <Construction size={48} style={{ color: content.color }} />
                    </div>

                    {/* Title */}
                    <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {content.title}
                    </h1>

                    {/* Description */}
                    <p className="text-gray-600 mb-8">
                        {content.description}
                    </p>

                    {/* Status Badge */}
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-50 text-amber-700 rounded-full mb-8">
                        <Clock size={18} />
                        <span className="text-sm font-medium">Under Development</span>
                    </div>

                    {/* Back Button */}
                    <div>
                        <button
                            onClick={() => navigate('/HomePage')}
                            className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
                        >
                            <ArrowLeft size={18} />
                            Return to Dashboard
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ComingSoon;
